import React, { FC } from "react";
import MUISkeleton, { SkeletonProps } from '@mui/material/Skeleton';

export const Skeleton: FC<SkeletonProps> = (props) => (
  <MUISkeleton {...props} />
);
